import DataLayer from "@/utils/DataLayer";
import { FC, useEffect, useRef } from "react";

interface IDataLayerEventProps {
    event: object;
    nonce?: string;
}

const DataLayerEvent: FC<IDataLayerEventProps> = ({
    event,
    nonce
}) => {
    const triggeredRef = useRef(false)
    const eventRef = useRef(event);
    eventRef.current = event;

    useEffect(() => {
        if (!eventRef.current || triggeredRef.current) {
            return;
        }

        triggeredRef.current = true;
        DataLayer.sendEvent(eventRef.current);

    }, [eventRef, triggeredRef, nonce])


    return null;
}

export default DataLayerEvent;